// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fade-animation-wrapper_wrapper__4WNB_","fadeIn":"fade-animation-wrapper_fadeIn__62Dge","fadeOut":"fade-animation-wrapper_fadeOut__z4sy6"};